export default {
	props: {
		priceToShow: String ,
		currency: String,
		isPreviousPrice: Boolean,
		showDetails: Boolean,
		showWarningPrice: Boolean,
		label: String,
		icon: {
			type: String,
			default: 'fas fa-money-bill'
		}
	}
}
